import axios from '@axios';

const base = '/api/v1/prison-users';

export default {
  login(username, password) {
    return axios.post(`${base}/tokens`, { username, password });
  },
  getUser() {
    return axios.get(`${base}/user`);
  },
  logoutChallenge(password) {
    return axios.post(`${base}/auth-challenge`, {password});
  },
};
